module.exports = __webpack_public_path__ + "assets/images/pedra_mult_44a129b73a6fbc8aa72d9f6a93333901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-montanha/pedra_mult.png
// module id = 167
// module chunks = 0